import type { AppLifecycle, AppUserInputData } from "./types.js";
import { DataModel } from "../../base/index.js";

export class AppUserInput extends DataModel<AppUserInputData> {
  public readonly lifecycle: AppLifecycle;
  public readonly step: string;
  public readonly name: string;
  public readonly dataType: string;
  public readonly format?: string;
  public readonly validationSchema: string;
  public readonly dataSource?: string;
  public readonly required: boolean;

  public constructor(data: AppUserInputData) {
    super(data);
    this.lifecycle = data.lifecycleConstraint;
    this.step = data.positionMeta?.step ?? "common";
    this.name = data.name;
    this.dataType = data.dataType;
    this.format = data.format;
    this.validationSchema = data.validationSchema;
    this.dataSource = data.dataSource;
    this.required = data.required;
  }
}
